/* eslint-disable */
export const USER_PERSIST_KEY = `bds:user`;

export const USER_SERVICE_PRESENCE_EVENT_NAMES = [
  `click`,
  `DOMMouseScroll`,
  `keydown`,
  `mousedown`,
  `mousemove`,
  `mousewheel`,
  `MSPointerMove`,
  `scroll`,
  `touchmove`,
  `touchstart`,
];

export const USER_SERVICE_PRESENCE_STATUS_AWAY = `away`;
export const USER_SERVICE_PRESENCE_STATUS_OFFLINE = `offline`;
export const USER_SERVICE_PRESENCE_STATUS_PRESENT = `present`;
export const USER_SERVICE_PRESENCE_STATUS_UNKNOWN = `unknown`;

export const USER_SERVICE_PRESENCE_TIMEOUT_THRESHOLD = 1 * 60 * 1000; // 1 minute

export const USER_MENU_MAIN = `main`;
export const USER_MENU_LANGUAGE = `language`;
export const USER_MENU_THEME = `theme`;
